module.exports = __webpack_public_path__ + "media/images/ln-img3-ef6e7aab3c9357781297cf8d4e2167ff.png";